// extracted by mini-css-extract-plugin
export default {"block":"id","smallprint":"jd","asterisk":"kd","label":"ld"};